<template>
  <SkeletonWishlistPage v-if="wishlistsLoading" :key="`${pageType}-skeleton-component`" :type="pageType" />
  <GuestListView v-else-if="pageType === 'guest'" />
  <MyListPage v-else :is-bread-crumb-ready="isBreadCrumbReady" />
</template>

<script setup>
import { isTemporaryGuestListGuidMatch, removeTemporaryGuestListGuid } from '#utils/temporaryGuestListStorage';

const { getAllWishlists, isGuestUser, isAuthenticated } = useWishlists();
const { wishlistGuidFromQuery, loadWishlistDetails, isGuestUserList } = useWishlistDetails();
const wishlistsLoading = ref(true);
const isBreadCrumbReady = ref(false);
const isRedirectingFromTemporaryGuestList = ref(false);

const route = useRoute();
const router = useRouter();

const isGuestPage = computed(() => isGuestUser.value || isGuestUserList.value || (!isAuthenticated.value && !wishlistGuidFromQuery.value));

const pageType = computed(() => (isGuestPage.value ? 'guest' : 'specific'));

const handleTemporaryGuestListRedirect = async () => {
  const currentListGuid = wishlistGuidFromQuery.value;

  if (!currentListGuid) {
    return;
  }

  if (isTemporaryGuestListGuidMatch(currentListGuid)) {
    isRedirectingFromTemporaryGuestList.value = true;
    await router.replace({ query: { ...route.query, listGuid: undefined } });
    removeTemporaryGuestListGuid();
  }
};

onBeforeMount(async () => {
  await handleTemporaryGuestListRedirect();

  if (!wishlistGuidFromQuery.value) {
    await getAllWishlists();
  }
  await loadWishlistDetails();
  wishlistsLoading.value = false;
  await nextTick();
  isBreadCrumbReady.value = true;
});

watch(
  () => route.query,
  async (newQuery, oldQuery) => {
    if (isRedirectingFromTemporaryGuestList.value) {
      isRedirectingFromTemporaryGuestList.value = false;
      return;
    }
    if (newQuery !== oldQuery) {
      wishlistsLoading.value = true;
      await loadWishlistDetails();
      wishlistsLoading.value = false;
    }
  },
);
</script>
